import { createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import { combineReducers } from 'redux';
import policyReducer from './reducers/policyReducer';


const rootReducer = combineReducers({
  policy: policyReducer,


});

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
